module.exports = __webpack_public_path__ + "static/img/ver-6.ab163757.png";